import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, useApp } from "@/context/AppContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { setUser } = useApp();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(data);
      } catch (err) {
        console.error("No se pudo crear la sesión de Google:", err);
      }
      window.history.replaceState(null, "", "/perfil");
      nav("/perfil", { replace: true });
    })();
  }, [location.hash, nav, setUser]);

  return <div className="min-h-screen bg-[#F7F5F0]" data-testid="auth-callback" />;
}
